import { render, staticRenderFns } from "./ProductResources.vue?vue&type=template&id=57a0a511&scoped=true&"
import script from "./ProductResources.vue?vue&type=script&lang=js&"
export * from "./ProductResources.vue?vue&type=script&lang=js&"
import style0 from "./ProductResources.vue?vue&type=style&index=0&id=57a0a511&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a0a511",
  null
  
)

export default component.exports